import type { UniDriver } from '@wix/unidriver-core';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';
import { dataHooks } from './FillPreview.constants';

export const fillPreviewDriverFactory = (base: UniDriver) => {
  const buttonSelector = `[data-hook="${dataHooks.button}"]`;

  return {
    ...baseUniDriverFactory(base),
    /** clicks on button */
    click: () => base.$(buttonSelector).click(),
    /** returns true if item is selected */
    isSelected: async () => {
      const dataSelected = await base.$(buttonSelector).attr('data-selected');

      return dataSelected === 'true';
    },
    /** returns the style attribute string of the button element */
    getButtonStyle: () => base.$(buttonSelector).attr('style'),
  };
};

export type FillPreviewUniDriver = ReturnType<typeof fillPreviewDriverFactory>;
